// File: src/blueprint/state/useBlueprintRouter.js

import { useCallback } from 'react';
import { ROUTES } from '../app/routes.js';
import { ACTIONS } from './blueprintReducer.js';
import { useBlueprintState } from './useBlueprintState.js';

export function useBlueprintRouter() {
  const { state, dispatch } = useBlueprintState();

  const goToEntry = useCallback(() => {
    dispatch({ type: ACTIONS.SET_ROUTE, payload: { route: ROUTES.ENTRY } });
  }, [dispatch]);

  const goToOverview = useCallback(() => {
    dispatch({ type: ACTIONS.SET_ROUTE, payload: { route: ROUTES.OVERVIEW } });
  }, [dispatch]);

  const openModule = useCallback(
    (moduleId, trackId) => {
      dispatch({ type: ACTIONS.OPEN_MODULE, payload: { moduleId, trackId } });
    },
    [dispatch]
  );

  const closeModule = useCallback(() => {
    dispatch({ type: ACTIONS.CLOSE_MODULE });
  }, [dispatch]);

  return {
    route: state.route,
    activeModuleId: state.activeModuleId,
    activeTrackId: state.activeTrackId,
    goToEntry,
    goToOverview,
    openModule,
    closeModule,
  };
}
